/**
 * The first-cycle soft-cap status (mission 9 WP13 T079; sheet 50 callout 4, sheet 51 callout 5's billing
 * half; B.5, B.3; FR-010; contracts/ui-api.md "Sheet 50").
 *
 * - `first-cycle-active`: `softCapActive`, the close date and the credits forgiven so far against the
 *   ceiling;
 * - `closed`: `softCapClosed`, what the first cycle forgave;
 * - `none`: nothing, when the soft cap is not active and forgave nothing.
 *
 * Every figure is the billing read's `soft_cap` (C-010); from the second cycle B.3's block applies.
 */
import type { SoftCap } from '@/lib/api/billing'
import { date } from '@/lib/format'
import { PROVISIONAL_COPY } from '@/lib/provisional-copy'

export function SoftCapStatus({ softCap }: { softCap: SoftCap }) {
  const { active, forgiven, ceiling, closes_at: closesAt } = softCap
  if (active && closesAt !== null) {
    return (
      <p data-testid="soft-cap-status" data-state="first-cycle-active" className="text-body-sm text-navy-700">
        {PROVISIONAL_COPY.softCapActive.render({ date: date(closesAt), forgiven, ceiling })}
      </p>
    )
  }
  if (forgiven > 0) {
    return (
      <p data-testid="soft-cap-status" data-state="closed" className="text-body-sm text-navy-700">
        {PROVISIONAL_COPY.softCapClosed.render({ forgiven })}
      </p>
    )
  }
  return null
}
